import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { DifficultyEnum } from '@/types/schema';

import { QUESTION_DIFFICULTY_CONFIG } from './config';

export const getMenuItems = (t: TFunction, difficultyLevel: DifficultyEnum): ActionMenuItemType[] =>
  Object.entries(QUESTION_DIFFICULTY_CONFIG).map(([level, { labelKey, Icon }]) => ({
    id: level,
    StartIcon: Icon,
    label: t(labelKey),
    endIcon:
      difficultyLevel === level ? (
        <CheckMark className="h-20 w-20" fillColorToken="icon-active" />
      ) : null,
  }));
